/**
 * This is just a random strings that reflects a value that's held in common between the client and server code to
 * represent a certain version of the UI code. The value doesn't change with each build or release, but instead a new
 * value needs to be manually added if there's a change to the client code that the server needs to be aware of.
 * We should keep them short (4 chars is more than enough), meaningless and unpredictable.
 * This version is reflected on the server in the `ClientVersion` class.
 */
export const UI_VERSION: string = 'NLER';
